import styled from 'styled-components'

export const StyleH2Heading = styled.h2`
  font-weight: bold;
  padding: 10px 35px;
`
